import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import {
  CATEGORIES_MENU,
  CATEGORIES_MENU_ROOT_NODE_ID,
  CategoriesMenuData,
  CategoriesMenuState,
} from '../categories-menu-state';
import { reducer as categoriesMenuReducer, initialState as initialCategoriesState } from './categories-menu.reducer';

export const initialState: CategoriesMenuState = {
  categoriesMenu: {
    ...StateUtils.initialLoaderState,
    value: initialCategoriesState,
  },
  rootNodeId: StateUtils.initialLoaderState,
};

export function getReducers(): ActionReducerMap<CategoriesMenuState> {
  return {
    categoriesMenu: StateUtils.loaderReducer<CategoriesMenuData>(CATEGORIES_MENU, categoriesMenuReducer),
    rootNodeId: StateUtils.loaderReducer<string>(CATEGORIES_MENU_ROOT_NODE_ID),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<CategoriesMenuState>> = new InjectionToken<
  ActionReducerMap<CategoriesMenuState>
>('CategoriesMenuReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
